import React, { useEffect, useRef, useState } from 'react'
import { enumUtil } from '../../../utils/Enum';
import SuperSearchList from '../SuperSearch/SuperSearchList';
import { ServerRequestProtected, ServerRequestPublic } from '../../../utils/ServerDataRequest';
import NotificationHandler from '../../../utils/NotificationHandler';
import FormValidator from '../../../utils/FormValidator';
import Loader from '../Loader/Loader';
import { useSelector } from 'react-redux';
import Modal from 'react-bootstrap/Modal';
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { Worker } from '@react-pdf-viewer/core';
import { Viewer } from '@react-pdf-viewer/core';
import isNull from '../../../utils/NullChecking';
import useHandleOpenNewBrowserTab from '../NewTabBrowser/useHandleOpenNewBrowserTab';

const BillingBatch = ({ ID, PaymentType, type, activeNotes }) => {
    let DropdownData = useSelector(state => state.GeneralDropDownsReducer)
    const handleOpenNewBrowserTab = useHandleOpenNewBrowserTab();

    // DropdownData?.BillingDocument
    const Billing_Modal = {
        BillingDocumentID: "",
        ClaimID: "",
        PatientID: "",
        HeaderID: "",
        PaymentType: "",
        NoofPages: "",
        FileName: '',
        File: '',
    }
    const Validation_Modal = {
        BillingDocumentID: '',
        NoOfPages: '',
        NoOfPagesLength: '',
    }
    let valModal = {}
    const API_URL = enumUtil.controller.General;
    const API_URL_Wasabi = enumUtil.controller.Wasabi;

    // const [billingBatchDocument, setBillingBatchDocument] = useState({});
    const [billingValidation, setBillingValidation] = useState(Validation_Modal);
    const [mainBillingModal, setMainBillingModal] = useState(Billing_Modal);
    const [saveBillingModal, setSaveBillingModal] = useState({});
    const [patientBody, setPatientBody] = useState({ "TableName": "", "SearchParam": '' });
    const [billingBatch, setBillingBatch] = useState('');
    const [is, setIs] = useState(false);
    const [noOfPages, setNoOfPages] = useState(null);
    const [isLoading, setIsLoading] = useState(false)
    const [file, setFile] = useState(null)
    const [defaultPageno, setDefaultPageNo] = useState(0)
    const defaultLayoutPluginInstance = defaultLayoutPlugin();
    const [reload, setReload] = useState()
    const fileInputRef = useRef(null);
    const [uploadFile, setUploadFile] = useState()
    const [isFileSelected, setIsFileSelected] = useState(false);
    const [isBillingDocSelected, setIsBillingDocSelected] = useState(false);

    const [pdfFile, setPdfFile] = useState(null);
    const [txtFile, setTxtFile] = useState(null);
    const [imgFile, setImgFile] = useState(null);
    const [modalActive, setModalActive] = useState(false)


    const FormValidatoR = (value, compareNumber) => {
        if (!isNull(compareNumber)) {
            if (parseInt(value) > parseInt(compareNumber)) {
                return (
                    <div className="invalid-feedback" style={{ display: "block" }}>
                        Invalid Page #
                    </div>
                )

            } else {
                return ''
            }
        }
        else {
            return (
                <div className="invalid-feedback" style={{ display: "block" }}>
                    Invalid Page #
                </div>
            )
        }

    }
    const formValidation = () => {
        let validationModal = {
            BillingDocumentID: isFileSelected
                ? ''
                : FormValidator(billingBatch, enumUtil.enumValidationType.Required, 'Batch'),
            // BillingDocumentID: FormValidator(billingBatch, enumUtil.enumValidationType.Required, 'Batch'),
            //  NoOfPages: FormValidator(mainBillingModal.NoofPages, enumUtil.enumValidationType.Required, 'No of Pages'),
            NoOfPages: isFileSelected
                ? ''
                : FormValidator(mainBillingModal.NoofPages, enumUtil.enumValidationType.Required, 'No of Pages'),
            // NoOfPagesLength: FormValidatoR(mainBillingModal.NoofPages, noOfPages),
            NoOfPagesLength: isFileSelected
                ? ''
                : FormValidatoR(mainBillingModal.NoofPages, noOfPages),
        }
        setBillingValidation(validationModal);
        valModal = validationModal;
    }
    const handleViewBillingBatchDocument = (bucketPath) => {
        let data = {
            name: 'ChildCustomView',
            type: "ViewBillingBatchDocument",

            data: {
                name: "ViewBillingBatchDocument",
                data: {
                    bucketPath: bucketPath,
                }
            }
        };
        handleOpenNewBrowserTab(data);
    }
    const handleOnChange = (e) => {
        const { name, value } = e.target;
        const modal = { ...mainBillingModal };
        const saveModal = { ...saveBillingModal };
        modal[name] = value;
        setMainBillingModal(modal);
        for (let property in modal) {
            if (property === name) {
                if (name != 'FileName') {
                    saveModal[name] = value;
                }
            }
        }
        setSaveBillingModal(saveModal);
    }
    const handleSelectedData = (selectedData, name, type) => {
        let modal = { ...mainBillingModal };
        let saveModal = { ...saveBillingModal };
        if (type === 'server' && !isNull(selectedData)) {
        } else if (type === 'client' && !isNull(selectedData)) {
            // setSearchParam(modal)
            if (name === 'BillingDocumentID') {
                if (selectedData?.value === '-1' || selectedData?.value === -1) {
                    modal['FileName'] = '';
                    saveModal['FileName'] = '';
                    modal['BillingDocumentID'] = '';
                    saveModal['BillingDocumentID'] = '';
                    setIsBillingDocSelected(false);



                }
                else {
                    modal['BillingDocumentID'] = selectedData?.display + '';
                    modal['FileName'] = selectedData?.FileName + '';
                    saveModal['BillingDocumentID'] = selectedData?.value + '';
                    saveModal['FileName'] = selectedData?.FileName + '';
                    setIsBillingDocSelected(true);
                    setIsFileSelected(false);


                }

                setNoOfPages(selectedData?.NoofPages);
                setBillingBatch(selectedData?.display);
                setMainBillingModal(modal);
            }
        } else {
            modal[name] = ''
            setNoOfPages('')
            setBillingBatch('')
        }
        setMainBillingModal(modal);
        setSaveBillingModal(saveModal);
        return selectedData
    }
    const handlePatientChange = (e) => {
        setIs(false);
        let { name, value } = e.target;
        setBillingBatch(value);

        // let modal = { ...mainAppointmentModal };
        // modal[name] = value;
        // setMainAppointmentModal(modal)
        setPatientBody({ "TableName": enumUtil.enumAPITableName.BILLINGDOCUMENT, "SearchParam": value });
    }
    const handleOnClose = () => {
        setMainBillingModal(Billing_Modal);
        setSaveBillingModal({});
        setBillingBatch('');
        setBillingValidation(Validation_Modal);
        setIsFileSelected(false)
        setIsBillingDocSelected(false)
    }
    const handleSaveBilling = () => {
        formValidation();
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck);
        if (validation) {
            return
        } else {
            if (type === 'Patient') {
                saveBillingModal["PatientID"] = ID + '';
            }
            if (type === 'Claim') {
                saveBillingModal["ClaimID"] = ID + '';
            }
            if (type === 'Payment') {
                saveBillingModal["HeaderID"] = ID + '';
                saveBillingModal['PaymentType'] = PaymentType + '';
            }
            const saveModal = {
                "TABLENAME": enumUtil.enumAPITableName.BILLINGDOCUMENTAPPLIED,
                "ID": mainBillingModal.BillingDocumentAppliedID || '0',
                "Data": { ...saveBillingModal }
            }
            setIsLoading(true);
            ServerRequestProtected(API_URL + '/SaveSingleRecord', 'post', saveModal).then((response) => {
                NotificationHandler('Record Saved Successfully', enumUtil.enumtoaster.success)
                setIsLoading(false)
                setReload(!reload)
            }).catch((error) => {
                setIsLoading(false);
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            })
        }
    }

    const LoadData = () => {
        setIsLoading(true);
        let id = type === 'Patient' ? { "PatientID": ID } :
            type === 'Claim' ? { "ClaimID": ID } :
                { "HeaderID": ID }
        ServerRequestProtected(API_URL + "/FindByID", 'post', {
            "TableName": enumUtil.enumAPITableName.BillingDocumentApplied,
            "SearchCriteria": {
                ...id,
                "PaymentType": PaymentType
            }
        }).then((response) => {
            setFile(response?.FileUrl)
            if (response.BillingDocumentName !== '') {
                setIsBillingDocSelected(true);
            }
            setIs(true);
            setBillingBatch(response.BillingDocumentName);

            setNoOfPages(response.TotelPages);
            setDefaultPageNo(response?.NoofPages)
            setIsLoading(false);
            setMainBillingModal(response)
        }).catch((error) => {
            setIsLoading(false);
        })
    }

    useEffect(() => {
        if (!isNull(reload)) {
            LoadData()
        }
    }, [reload])
    useEffect(() => {
        if (activeNotes) {
            LoadData()
        }
    }, [activeNotes])



    const ViewPdf = () => {
        handleViewBillingBatchDocument(file);

        // setPdfFile(null)
        // setTxtFile(null)
        // setImgFile(null)
        // setIsLoading(true)
        // ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
        //     "BucketPath": file
        // }, 'Download').then((response) => {
        //     setIsLoading(false)
        //     if (response.type === 'application/txt') {
        //         const blob = response;
        //         const reader = new FileReader();
        //         reader.onload = () => {
        //             const content = reader.result;
        //             setTxtFile(content);
        //         };

        //         reader.readAsText(blob, 'utf-8');
        //     } else if (response.type === 'application/png') {
        //         const blob = response
        //         const objectURL = URL.createObjectURL(blob);
        //         setImgFile(objectURL)
        //     } else if (response.type === 'application/tiff') {
        //         const blob = response
        //         const objectURL = URL.createObjectURL(blob);
        //         setImgFile(objectURL)
        //     }
        //     else if (response.type === 'application/pdf') {
        //         const blob = response
        //         const objectURL = URL.createObjectURL(blob);
        //         setPdfFile(objectURL)
        //     }
        //     else {
        //         let file = new Blob([response]);
        //         const fileUrl = URL.createObjectURL(file);
        //         setPdfFile(fileUrl)
        //     }
        //     setModalActive(true)
        // }).catch((error) => {
        //     setIsLoading(false)
        //     NotificationHandler('File Not Found', enumUtil.enumtoaster.error);
        // })
    }


    const savefile = (e) => {
        const { name, files } = e.target;
        const file = files[0]; // Get the selected file

        if (!file) return; // If no file is selected, return early
        setIsFileSelected(true);       // <- ADD THIS
        setIsBillingDocSelected(false)

        const modalCopy = { ...mainBillingModal };
        const saveModalCopy = { ...saveBillingModal };

        // Set the file name in both state objects
        if (name === 'File') {
            modalCopy['FileName'] = file.name;
            saveModalCopy['FileName'] = file.name;
        }

        setMainBillingModal(modalCopy);
        setSaveBillingModal(saveModalCopy);

        // Define supported file types
        const supportedFileTypes = [
            'image/png',
            'image/jpeg',
            'image/jpg',
            'application/pdf',
            'application/msword',
            'text/plain',
        ];

        // Check if the file type is supported
        if (
            supportedFileTypes.includes(file.type) ||
            file.name.endsWith('.pdf') ||
            file.name.endsWith('.doc') ||
            file.name.endsWith('.tex') ||
            file.name.endsWith('.jpg') ||
            file.name.endsWith('.png')
        ) {
            const reader = new FileReader();

            reader.onloadend = (event) => {
                const value = reader.result.toString();
                modalCopy[name] = value; // Base64 encoded string

                setMainBillingModal({ ...modalCopy });
                for (const property in modalCopy) {
                    if (name === property) {
                        saveModalCopy[name] = event.target.result.split("base64,")[1];
                    }
                }

                setSaveBillingModal({ ...saveModalCopy });
            };

            reader.readAsDataURL(file);
        }
    };

    console.log(mainBillingModal?.FileName, 'fileName');

    const removeFile = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
        setUploadFile(null);
        const updatedMainBillingDocumentModal = { ...mainBillingModal };
        updatedMainBillingDocumentModal['FileName'] = '';
        setMainBillingModal({ ...updatedMainBillingDocumentModal, File: '' });
        setSaveBillingModal({ ...saveBillingModal, File: '', FileName: '' })

        setIsBillingDocSelected(false);
        setIsFileSelected(false);
    };
    const [billingBatchDD, setBillingBatchDD] = useState([])
    const API_URL_GENERAL = enumUtil.controller.Claim

    useEffect(() => {
        handleRereash()
    }, []);
    const handleRereash = (data) => {
        setIsLoading(data === 'true' ? true : false)
        ServerRequestProtected(API_URL_GENERAL + "/GetBillingDocument", 'post', {
            "TableName": enumUtil.enumAPITableName.Claim
        }).then((response) => {
            setBillingBatchDD(response)
            setIsLoading(false)
            console.response("response", response)
        }).catch((error) => {
            setIsLoading(false)

        })
    }
    return (
        <>
            <div>
                {isLoading ? <Loader /> : null}
                <div className="patient_notes_content">
                    <div className="m-2">
                        <div className="ar_upload-bill-pay position-relative  mb-2">
                            {isFileSelected === true
                                ? null
                                :
                                <div className={`form-control ${isBillingDocSelected ? 'ar-disable' : ''}`}>
                                    <input type="file"
                                        className="inputfile bottom-0 end-0 inputfile opacity-0 position-absolute start-0 top-0"
                                        id="File"
                                        name="File"
                                        accept=".pdf"
                                        onChange={savefile}
                                        ref={fileInputRef}
                                        disabled={isBillingDocSelected}

                                    />
                                    <label for="file" className='d-flex align-items-center gap-1 h-100 justify-content-center'>
                                        <i className="icon-Icon-metro-attachment" ></i>
                                        <p className='text fs-13 fst-italic ar-light-color'> Upload a File</p>
                                    </label>
                                </div>
                            }



                        </div>
                        {isFileSelected === true ?

                            <div className="d-flex align-items-center gap-2">
                                <p className="heading">{mainBillingModal?.FileName}</p>
                                <i className="icon-delete text-danger fs-12" onClick={removeFile}></i>
                            </div>
                            : null}

                        <p className='text fs-13 fst-italic text-center mb-2'>Or</p>
                        <div className={'mb-2 input'}>
                            <div className="d-flex justify-content-between">
                                <label htmlFor="">Batch #</label>
                                <i className="icon-reload fs-13" onClick={() => handleRereash("true")}></i>
                            </div>
                            <div className={billingValidation.BillingDocumentID ? 'mb-2 input error' : 'mb-2 input'}>

                                <SuperSearchList
                                    type='client'
                                    name='BillingDocumentID'
                                    id='BillingDocumentID'
                                    // method="post"
                                    data={billingBatchDD}
                                    // ApiLink={API_URL + "/InstantSearch"}
                                    // postBody={patientBody}
                                    getSelectedData={handleSelectedData}
                                    onChange={handlePatientChange}
                                    searchValue={billingBatch}
                                    is={is}
                                    sup_btn='sup_btn-Inp'
                                    sup_inp='superSearchVisitInp'
                                    placeholder={false}
                                    // icon={true}
                                    autocomplete={false}
                                    isReadOnly={isFileSelected}
                                    inputError={billingValidation.BillingDocumentID}
                                />
                                {billingValidation.BillingDocumentID}
                            </div>
                        </div>
                        <div className="input">
                            <label for="">File Name</label>
                            <input variant="outlined" type="text" maxlength="35" class="form-control" name="FileName" id="FileName" autocomplete="off" disabled={true} value={mainBillingModal.FileName} onChange={handleOnChange} />
                        </div>
                        <div className='input my-2'>
                            <div className="d-flex justify-content-between align-items-center pe-1">
                                {/* <label for="">Page #</label> */}
                                <label for="">Page #(1-{noOfPages ? noOfPages : 'N/A'})</label>
                                {/* <i className="xsm_heading">Total Pages: {noOfPages ? noOfPages : 'N/A'}</i> */}
                                <i className='icon-Icon-awesome-eye fs-12' onClick={ViewPdf}></i>
                            </div>
                            <div className={billingValidation.NoOfPages || billingValidation.NoOfPagesLength ? 'error input' : 'input'}>
                                <input variant="outlined" type="text" maxlength="35" className='form-control' name="NoofPages" id="NoofPages" autocomplete="off" value={mainBillingModal.NoofPages}
                                    disabled={isFileSelected}
                                    onChange={handleOnChange} />
                                {billingValidation.NoOfPages}
                                {billingValidation.NoOfPagesLength}
                            </div>
                        </div>

                        <div className="btns-group-flex justify-content-end claims_btns">
                            <button className="btn btn-gray mt-3 btn-xs no-width rounded me-1" onClick={handleOnClose}>Cancel</button>
                            <button className="btn mt-3 btn-orange btn-xs no-width rounded" onClick={handleSaveBilling}>Save</button>
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={modalActive} onHide={() => setModalActive(false)} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-md hk-login-v1 hk-modal-v1">
                <Modal.Body>
                    <div className="download-header">
                        <div className='hide-me'></div>
                        {/* <button className="btn download-btn">
                      Download PDF
                    </button> */}

                        <button className="btn-icon-transparent" onClick={() => setModalActive(false)}>
                            <i className="icon-Icon-metro-cross"></i>
                        </button>
                    </div>
                    <div className="pdfView-box">

                        {!isNull(txtFile) ? txtFile : ''}
                        {!isNull(imgFile) ? <img src={imgFile} alt='Image' /> : ''}

                    </div>
                    {isLoading ? <Loader /> : null}

                    {pdfFile &&
                        <>
                            <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
                                <Viewer fileUrl={pdfFile}
                                    defaultScale={1}
                                    plugins={[defaultLayoutPluginInstance]}
                                    initialPage={defaultPageno - 1} />
                            </Worker>
                        </>
                    }
                </Modal.Body>
                <div className='btns-group text-end px-3 py-3 br-top-1 br-clr'>
                    <button className='btn btn-gray' onClick={() => setModalActive(false)}>Cancel</button>
                </div>
            </Modal>
        </>

    )
}

export default BillingBatch
